module.exports = __webpack_public_path__ + "static/media/VectorCofirm.2a900335.svg";